import { render, staticRenderFns } from "./MaintenanceCommentForm.vue?vue&type=template&id=634ef458"
import script from "./MaintenanceCommentForm.vue?vue&type=script&lang=js"
export * from "./MaintenanceCommentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports